import t, { css as a } from "styled-components";
import { UL as i, LI as n } from "./atoms-v2777.js";
const p = t.ul`
  ${i}
  ${({ theme: o }) => {
  var r;
  return (r = o == null ? void 0 : o.get("tokens.body.productive")) == null ? void 0 : r.toJS();
}}
  --column-gap: 8px;

  align-items: ${({ $variant: o }) => o === "vertical" ? "flex-start" : "center"};
  color: ${({ $colorTheme: o = "light", theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.tertiary`)};
  display: flex;
  flex-flow: ${({ $variant: o }) => o === "vertical" ? "column wrap" : "row wrap"};
  flex-wrap: wrap;
  gap: ${({ $hasIcons: o }) => `8px ${o ? "calc(var(--column-gap) * 2)" : 0}`};
  justify-content: center;
  transition: color ${({ theme: o }) => o == null ? void 0 : o.get("tokens.motion").toString("duration.moderate.02")}
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.motion").toString("easing.standard")};

  ${({ $hasIcons: o }) => !o && a`
      & ${l} + ${l}::before {
        --bullet-size: 3px;

        background-color: currentcolor;
        border-radius: 50%;
        content: '';
        height: var(--bullet-size);
        margin-left: var(--column-gap);
        vertical-align: middle;
        width: var(--bullet-size);
      }
    `}
`, l = t.li`
  ${n}

  align-items: center;
  column-gap: var(--column-gap);
  display: flex;
`;
l.displayName = "Specs.Spec";
export {
  l as Spec,
  p as Specs
};
